import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { SecurityService } from '@core/Security/security.service';
import { EventsEmitterService } from '@core/Abstract/emitter.service';
import { LogService } from '@core/Abstract/log.service';
import { VisualsService } from '@core/Abstract/visuals.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-notifications',
    template: `<div class="material toastrContainer"></div>`
})
export class NotificationsComponent {

    public toastrSubscription: Subscription;

    public toastrConfig: Partial<IndividualConfig> = {
      timeOut: 7000,
      positionClass: 'toast-top-right',
      newestOnTop: false,
      progressBar: true,
      progressAnimation: 'increasing',
    };
  
    protected genericVis = {};


    constructor(private securityService: SecurityService,
        private eventsEmitterService: EventsEmitterService,
        private logger: LogService,
        private visualsService: VisualsService,
        protected toastr: ToastrService
        ) {


        this.loadVisuals();
        this.eventsEmitterService.languageChange.subscribe(
            langId => {
                this.loadVisuals();
            }
        );

        this.toastrSubscription = LogService.alertCreate.subscribe({
            next: (alertJSON) => {
              if (alertJSON.hasOwnProperty('type')) {
                switch (alertJSON.type) {
                  case 'error':
                    this.toastr.error(alertJSON.body, this.genericVis[alertJSON.type], this.toastrConfig);
                    break;
      
                  case 'success':
                    this.toastr.success(
                      alertJSON.body,
                      this.genericVis[alertJSON.type],
                      this.toastrConfig,
                    );
                    break;
      
                  case 'info':
                    this.toastr.info(alertJSON.body, this.genericVis[alertJSON.type], this.toastrConfig);
                    break;
      
                  case 'warning':
                    this.toastr.warning(
                      alertJSON.body,
                      this.genericVis[alertJSON.type],
                      this.toastrConfig,
                    );
                    break;
      
                  default:
                    this.toastr.error(alertJSON.body, this.genericVis['error'], this.toastrConfig);
                }
              } else {
                this.toastr.error(alertJSON.body, 'Error', this.toastrConfig);
              }
            },
        });

    }

    ngOnInit(): void { }

    protected loadVisuals(): void {
        this.genericVis = this.visualsService.getFromStorageAsJSON('visualsArray') ? this.visualsService.getFromStorageAsJSON('visualsArray')['generic'] : {};
    }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        this.toastrSubscription.unsubscribe();
    }

}
